import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";

function QiFrame({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    //=========================
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const src = input.URL?.value;
    const frameBorder = "0";
    const marginHeight = "0";
    const marginWidth = "0";

    return (
        <div
            style={{
                width: "100%",
                height: input.height,
                ...fixStyle,
                ...style,
                "&:hover": decodeStyle(ps.hover, gs),
                ...tabletStyle,
                ...mobileStyle,
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    ...decodeStyle(ps.style, gs),
                    // "&:hover": decodeStyle(ps.hover, gs),
                    ...(tablet(device) && decodeStyle(ps.tablet, gs)),
                    ...(mobile(device) && decodeStyle(ps.mobile, gs)),
                    width: input.canvasSize?.value,
                    // maxWidth: "100%",
                    alignSelf: input.alignVideo,
                    overflow: "hidden",
                }}
            >
                {/* <InstagramEmbed embedCode={insta_code} /> */}
                {/* <TweetEmbed embedCode={tweet_code} /> */}

                <iframe
                    title={id}
                    width="100%"
                    height={input.height || 200}
                    frameBorder={
                        frameBorder === undefined ? 0 : `${frameBorder}`
                    }
                    // scrolling={scrolling === undefined ? "no" : `${scrolling}`}
                    marginHeight={
                        marginHeight === undefined ? "0" : `${marginHeight}`
                    }
                    marginWidth={
                        marginWidth === undefined ? "0" : `${marginWidth}`
                    }
                    src={src === undefined ? {} : `${src}`}
                ></iframe>
            </div>
        </div>
    );
}

export default QiFrame;
